/**
 * @generated SignedSource<<d67d7ed9982d562ffeea641291fed62a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AlimTalkTaskCreateInput = {
  csvFile?: Upload | null;
  description?: string | null;
  period?: number | null;
  query: string;
  startAt: any;
  templateCodeId: string;
  title: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation$variables = {
  input: AlimTalkTaskCreateInput;
};
export type AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation$data = {
  readonly alimTalkTaskCreate: {
    readonly id: string;
  };
};
export type AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation = {
  response: AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation$data;
  variables: AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AlimTalkTask",
    "kind": "LinkedField",
    "name": "alimTalkTaskCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "724995cd8fdc013b1ba51581918d30b8",
    "id": null,
    "metadata": {},
    "name": "AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation",
    "operationKind": "mutation",
    "text": "mutation AlimTalkTaskCreateDialog_alimTalkTaskCreateMutation(\n  $input: AlimTalkTaskCreateInput!\n) {\n  alimTalkTaskCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eecc2b5e3b6b5b92906fa60558ce9917";

export default node;
